import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import httpClient from "../../services/httpClient";
import Logger from "../../utils/Logger";
import { useAuth } from "../../AuthContext";
import orangeSortIcon from "../../media/orange-sort-icon.svg";
import "../../styleSheet/main/admin/manageCars/manageCars.scss";

const randomHexColor = () =>
  "#" + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0");

const AddCar = () => {
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [licensePlate, setLicensePlate] = useState("");
  const [colorHex, setColorHex] = useState(randomHexColor);
  const [errors, setErrors] = useState({});
  const [hover, setHover] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { userData } = useAuth();

  // Sprawdź czy użytkownik jest adminem
  React.useEffect(() => {
    if (userData.userRole !== "admin") {
      navigate("/");
    }
  }, [userData, navigate]);

  const handleBackClick = () => {
    navigate("/administrator/samochody");
  };

  const validateForm = () => {
    const newErrors = {};

    if (!make.trim()) {
      newErrors.make = "Proszę podać markę samochodu";
    }

    if (!model.trim()) {
      newErrors.model = "Proszę podać model samochodu";
    }

    if (!licensePlate.trim()) {
      newErrors.licensePlate = "Proszę podać numer rejestracyjny";
    } else if (!/^[A-Z0-9\s-]+$/i.test(licensePlate.trim())) {
      newErrors.licensePlate =
        "Numer rejestracyjny może zawierać tylko litery, cyfry, spacje i myślniki";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const carData = {
        make: make.trim(),
        model: model.trim(),
        licensePlate: licensePlate.trim().toUpperCase(),
        colorHex,
      };

      await httpClient.post("/Cars", carData, { withAuth: true });

      // Sukces - przekieruj do listy samochodów
      navigate("/administrator/samochody");
    } catch (error) {
      Logger.error("Błąd podczas dodawania samochodu:", error);
      setErrors({
        submit:
          error.response?.data?.message ||
          "Nie udało się dodać samochodu. Spróbuj ponownie.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="manage-cars-container">
      <div className="manage-cars-header">
        <h1>Dodaj nowy samochód</h1>
        <div
          className="orange-sort-icon"
          onClick={handleBackClick}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            backgroundImage: `url(${orangeSortIcon})`,
            transform: hover ? "rotate(180deg)" : "rotate(90deg)",
            cursor: "pointer",
          }}
        />
      </div>

      <form className="car-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="make">Marka samochodu *</label>
          <input
            type="text"
            id="make"
            value={make}
            onChange={(e) => setMake(e.target.value)}
            placeholder="np. Toyota"
            disabled={isSubmitting}
          />
          {errors.make && <span className="error-message">{errors.make}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="model">Model samochodu *</label>
          <input
            type="text"
            id="model"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            placeholder="np. Corolla"
            disabled={isSubmitting}
          />
          {errors.model && (
            <span className="error-message">{errors.model}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="licensePlate">Numer rejestracyjny *</label>
          <input
            type="text"
            id="licensePlate"
            value={licensePlate}
            onChange={(e) => setLicensePlate(e.target.value)}
            placeholder="np. WA 12345"
            disabled={isSubmitting}
          />
          {errors.licensePlate && (
            <span className="error-message">{errors.licensePlate}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="colorHex">Kolor</label>
          <input
            type="color"
            id="colorHex"
            value={colorHex}
            onChange={(e) => setColorHex(e.target.value)}
            disabled={isSubmitting}
          />
        </div>

        {errors.submit && (
          <div className="error-message submit-error">{errors.submit}</div>
        )}

        <div className="form-actions">
          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Dodawanie..." : "Dodaj samochód"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCar;
